import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/91f0fbb4-559d-4c0a-96a3-54de25a4114a/265ef432-731f-4807-9f14-e7a59a16899d_baku-2024-2025-_2555168725-scaled.jpeg?v=a60822f54c9b8f3c5a6460bad361db0b"
          alt="Mail.net.az Hero"
          className="w-full h-full object-cover object-center"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/55" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 pt-20">
        <span className="inline-block bg-white/15 border border-white/30 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide backdrop-blur-sm">
          <i className="ri-flag-line mr-1.5" />
          {t("home.hero_tag")}
        </span>
        <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-5 max-w-3xl mx-auto">
          {t("home.hero_title")}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-xl mx-auto mb-9 leading-relaxed">
          {t("home.hero_subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <Link
            to="/register"
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-3.5 rounded-full cursor-pointer transition-all text-sm whitespace-nowrap inline-flex items-center gap-2"
          >
            {t("home.hero_cta")}
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/login"
            className="border border-white/50 text-white hover:bg-white/10 font-medium px-8 py-3.5 rounded-full cursor-pointer transition-all text-sm whitespace-nowrap backdrop-blur-sm"
          >
            {t("home.hero_login")}
          </Link>
        </div>

        {/* Trust Badges */}
        <div className="mt-14 flex flex-wrap justify-center gap-6 text-white/60 text-xs">
          {[
            { icon: "ri-shield-check-line", text: "AES-256 Encryption" },
            { icon: "ri-government-line", text: "Dövlət Standartları" },
            { icon: "ri-id-card-line", text: "FİN Doğrulaması" },
          ].map((b) => (
            <div key={b.text} className="flex items-center gap-1.5">
              <i className={`${b.icon} text-green-400 text-base`} />
              <span>{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
